import React, {useEffect, useState} from "react";
import SectionContentBox from "../SectionContentBox";
import SectionParagraph from "../SectionParagraph";
import apiService from "../../services/apiService";
import {aboutUsImg} from "../../assets/images";
import {useLanguage} from "../../hooks/LanguageContext";
import {LogoAsBg} from "../../assets/icons"; // Assuming you have a language context

const AboutUs = ({ displayImgs = true, hideBtn = false }) => {
	const { direction, language } = useLanguage(); // Get language direction (ltr/rtl) and language
	const baseUrl = process.env.REACT_APP_BACKEND_BASE_URL; // Access the base URL
	const [data, setData] = useState([]);
	const [selectedImage, setSelectedImage] = useState(null); // State to track the selected image

	useEffect(() => {
		apiService
			.getAboutUs()
			.then((response) => {
				setData(response.data);
				if (response.data.length > 0) {
					setSelectedImage(`${baseUrl}/${response.data[0].image}`); // Default to the first item's image
				}
			})
			.catch((err) => {
				console.error(err);
			});
	}, [baseUrl]);

	const handleImageError = (e) => {
		e.target.src = aboutUsImg; // Set fallback image if the original image fails to load
	};

	return (
		<>
			{displayImgs && (
				<>
					<LogoAsBg
						className={`opacity-30 md:opacity-70 lg:opacity-100 absolute z-[9999] mt-28 overflow-hidden ${
							direction === "rtl" ? "-right-28" : "scale-x-[-1]   -left-28 "
						}`}
					/>
				</>
			)}
			<section className={`mt-[80px] container relative overflow-hidden ${direction === "rtl" ? "text-right" : "text-left"}`}>


				<div className="container z-50">
					<SectionContentBox
						title={language === "ar" ? "نبذه عنا" : "About Us"}
						hideBtn={hideBtn}
						href="/about"
						headline={
							<>
								{language === "ar" ? (
									<>
										تعرف على <span className="text-primary-700"> الفايز قيادة </span>
										<br />
										الثقة في عالم نقل السيارات
									</>
								) : (
									<>
										Discover <span className="text-primary-700">Al-Faiz Leadership</span>
										<br />
										Trust in the world of car transportation
									</>
								)}
							</>
						}
						buttonText={language === "ar" ? "معرفة المزيد" : "Learn More"}
					/>

					<section className="w-full flex md:flex-row flex-col items-center lg:gap-12 gap-6 z-50">

						<div className="md:w-[55%] w-full md:h-[914px] h-auto flex flex-col items-start md:gap-[30px] gap-6">
							{data.map((item) => (
								<div
									className={`w-full cursor-pointer z-50 md:h-[220px] h-auto flex md:flex-row flex-col justify-between items-center md:py-[30px] py-[15px] px-[15px] bg-bg-light shadow-aboutUs-shadow md:rounded-[30px] rounded-xl`}
									key={item.id}
									onMouseEnter={() => setSelectedImage(`${baseUrl}/${item.image}`)} // Set the selected image on hover
									onClick={() => setSelectedImage(`${baseUrl}/${item.image}`)} // Set the selected image on click
								>
                			<span className="flex md:hidden">
                  <img
					  className="md:w-auto md:h-auto h-20 w-20"
					  src={`${baseUrl}/${item.icon}`}
					  alt={item.name_ar + "icon"}
				  />
                </span>

									<div className="flex flex-col gap-2 items-center px-[12px] lg:px-[20px]">
										<h3 className="headline-4-ar lg:headline-3-ar text-grayscale-600">
											{language === "ar" ? item.title_ar : item.title_en}
										</h3>

										<SectionParagraph paragraph={language === "ar" ? item.description_ar : item.description_en} />
									</div>
									<span className="md:flex hidden">
                  <img
					  className="h-20 w-20 md:w-60 md:h-60"
					  src={`${baseUrl}/${item.icon}`}
					  alt={item.title_en + "iconm"}
				  />
                </span>
								</div>
							))}
						</div>
						<div className="md:w-[45%]  z-50 w-full md:h-[647px] h-full">
							{/* Dynamically change the image */}
							{selectedImage && (
								<img
									src={selectedImage}
									alt={language === "ar" ? "نبذه عنا" : "About Us"}
									onError={handleImageError}
								/>
							)}
						</div>
					</section>
				</div>
			</section>

		</>
	);
};

export default AboutUs;
